import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5c7af42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-card topup" }
const _hoisted_2 = { class: "topup-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "当前余额")
], -1))
const _hoisted_4 = { class: "balance" }
const _hoisted_5 = { class: "account" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "¥", -1))
const _hoisted_7 = { class: "num" }
const _hoisted_8 = { class: "options" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "g-card options-container" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "$", -1))
const _hoisted_13 = { class: "amount" }
const _hoisted_14 = {
  key: 0,
  class: "tip"
}
const _hoisted_15 = {
  key: 1,
  class: "hot-tip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Statement = _resolveComponent("Statement")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper container", { 'large-padding': _ctx.isLargeScreen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userInfo.balance), 1)
          ]),
          _createElementVNode("div", {
            class: "tip hover",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navTradeList && _ctx.navTradeList(...args)))
          }, [
            _createTextVNode(" 查看账单明细 "),
            _createVNode(_component_Icon, { class: "g-icon icon-btn_arrow_right" })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Icon, {
          class: "g-icon",
          icon: "icon_recharge"
        }),
        _createTextVNode(" 美金充值 ")
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chargeOptions, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["charge-options", { selected: _ctx.curSelectedIndex === index }]),
            key: index,
            onClick: ($event: any) => (_ctx.selectOption(index))
          }, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(item.amount), 1),
            (item.tip)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.tip), 1))
              : _createCommentVNode("", true),
            (item.hotTip)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.hotTip), 1))
              : _createCommentVNode("", true)
          ], 10, _hoisted_11))
        }), 128))
      ])
    ]),
    _createVNode(_component_Statement, { class: "statement" }),
    _createElementVNode("div", {
      class: "footer-ctrl g-fixed hover",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.payWithStripeUrl && _ctx.payWithStripeUrl(...args)))
    }, " 立即充值 ")
  ], 2))
}